export default __webpack_public_path__ + "static/media/Bootstrap-Logo.527d0fc0.svg";